module.exports = __webpack_public_path__ + "static/media/mariposa-02.2ac9c466.jpg";